/*============================================================================
  Ajax the add to cart experience by revealing it in a side drawer
  Plugin Documentation - http://shopify.github.io/Timber/#ajax-cart
  (c) Copyright 2015 Shopify Inc. Author: Carson Shold (@cshold). All Rights Reserved.

  This file includes:
    - Basic Shopify Ajax API calls
    - Ajax cart plugin

  This requires:
    - jQuery 1.8+
    - handlebars.min.js (for cart template)
    - modernizr.min.js
    - snippet/ajax-cart-template.liquid

  Customized version of Shopify's jQuery API
  (c) Copyright 2009-2015 Shopify Inc. Author: Caroline Schnapp. All Rights Reserved.
==============================================================================*/
if ((typeof ShopifyAPI) === 'undefined') { ShopifyAPI = {}; }

/*============================================================================
  API Helper Functions
==============================================================================*/
function attributeToString(attribute) {
  if ((typeof attribute) !== 'string') {
    attribute += '';
    if (attribute === 'undefined') {
      attribute = '';
    }
  }
  return jQuery.trim(attribute);
};

/*============================================================================
  API Functions
==============================================================================*/
ShopifyAPI.onCartUpdate = function(cart) {
  // alert('There are now ' + cart.item_count + ' items in the cart.');
};

ShopifyAPI.updateCartNote = function(note, callback) {
  var $body = $(document.body),
  params = {
    type: 'POST',
    url: '/cart/update.js',
    data: 'note=' + attributeToString(note),
    dataType: 'json',
    beforeSend: function() {
      $body.trigger('beforeUpdateCartNote.ajaxCart', note);
    },
    success: function(cart) {
      if ((typeof callback) === 'function') {
        callback(cart);
      }
      else {
        ShopifyAPI.onCartUpdate(cart);
      }
      $body.trigger('afterUpdateCartNote.ajaxCart', [note, cart]);
    },
    error: function(XMLHttpRequest, textStatus) {
      $body.trigger('errorUpdateCartNote.ajaxCart', [XMLHttpRequest, textStatus]);
      ShopifyAPI.onError(XMLHttpRequest, textStatus);
    },
    complete: function(jqxhr, text) {
      $body.trigger('completeUpdateCartNote.ajaxCart', [this, jqxhr, text]);
    }
  };
  jQuery.ajax(params);
};

ShopifyAPI.onError = function(XMLHttpRequest, textStatus) {
  var data = eval('(' + XMLHttpRequest.responseText + ')');
  if (!!data.message) {
    alert(data.message + '(' + data.status  + '): ' + data.description);
  }
};

/*============================================================================
  POST to cart/add.js returns the JSON of the cart
    - Allow use of form element instead of just id
    - Allow custom error callback
==============================================================================*/
ShopifyAPI.addItemFromForm = function(form, callback, errorCallback) {
  var $body = $(document.body),
  params = {
    type: 'POST',
    url: '/cart/add.js',
    data: jQuery(form).serialize(),
    dataType: 'json',
    beforeSend: function(jqxhr, settings) {
      $body.trigger('beforeAddItem.ajaxCart', form);
    },
    success: function(line_item) {
      if ((typeof callback) === 'function') {
        callback(line_item, form);
      }
      else {
        ShopifyAPI.onItemAdded(line_item, form);
      }
      $body.trigger('afterAddItem.ajaxCart', [line_item, form]);
      // guardianAPI.gtag_report_conversion_add_to_cart(line_item)
      guardianAPI.segment_report_conversion_add_to_cart(line_item)
      guardianAPI.gb_report_conversion_add_to_cart(line_item)
      guardianAPI.ctv_add_to_cart(line_item)
      guardianAPI.amazon_add_to_cart(line_item)
      // guardianAPI.reddit_add_to_cart(line_item)
      // guardianAPI.klaviyoAddToCart(line_item)

      // console.log("_learnq", _learnq)
      // if (_learnq) {
      //   _learnq.push(['track', 'Added to Cart', line_item]);
      // }
      
      
      let optionalAddonItems = Array.from(document.querySelectorAll('.optional-accessory-input:checked')).map((each) => {
        var itemToAdd = {id: each.id, quantity: 1, properties: {'_ATC': 'PDP - Checkbox'}}
        if (each.dataset.preorderDate) {
          itemToAdd.properties['Type'] = 'Pre-order'
          itemToAdd.properties['Ship Date'] = each.dataset.preorderDate
        }
        return itemToAdd
      })
      // if (optionalAddonItems.length) {
      //   guardianAPI.addMultipleItemsToCart(optionalAddonItems)
      // }

      let optionalBundles = [];
      Array.from(document.querySelectorAll('.recommended-bundle--selected')).forEach((each) => {
        let variantsIds = JSON.parse(each.dataset.variants)
        variantsIds.forEach(variantsId => {
          let bundleVariant = $('.recommended-bundle-item[data-id="'+variantsId+'"]', each)
          let preorderDate = bundleVariant && bundleVariant.length > 0 ? bundleVariant[0].dataset.preorderDate : null;
          // optionalBundles.push({id: variantsId, quantity: 1, properties: {'_ATC': 'PDP - Checkbox'}})
          if (preorderDate) {
            optionalBundles.push({id: variantsId, quantity: 1, properties: {'_ATC': 'PDP - Checkbox', 'Ship Date': preorderDate, 'Type': 'Pre-order'}})
          } else {
            optionalBundles.push({id: variantsId, quantity: 1, properties: {'_ATC': 'PDP - Checkbox'}})
          }
        })
      })

      // let accessoryOfferName = 'accessories_added_aug_2_2025'
      // let accessoryOfferAdded = guardianAPI.getCookie(accessoryOfferName)
      // let discountCode = guardianAPI.getCookie('discount_code')
      
      // if (!accessoryOfferAdded) {
      //   if (!optionalBundles.length) {
      //     guardianAPI.setCookie(accessoryOfferName, true)
      //     Array.from(document.querySelectorAll('.recommended-bundles--active .recommended-bundle--active')).forEach((each) => {
      //       let variantsIds = JSON.parse(each.dataset.variants)
      //       variantsIds.forEach(variantsId => {
      //         let bundleVariant = $('.recommended-bundle-item[data-id="'+variantsId+'"]', each)
      //         let preorderDate = bundleVariant && bundleVariant.length > 0 ? bundleVariant[0].dataset.preorderDate : null;
      //         // optionalBundles.push({id: variantsId, quantity: 1, properties: {'_ATC': 'PDP - Checkbox'}})
      //         if (preorderDate) {
      //           optionalBundles.push({id: variantsId, quantity: 1, properties: {'_ATC': 'PDP - Checkbox', 'Ship Date': preorderDate, 'Type': 'Pre-order'}})
      //         } else {
      //           optionalBundles.push({id: variantsId, quantity: 1, properties: {'_ATC': 'PDP - Checkbox'}})
      //         }
      //       })
      //     })
      //   }
      // }
      
      var bundleItemsToAdd = []
      var bundleContainer = document.getElementById("bike-bundle-container")
      if (bundleContainer && !bundleContainer.classList.contains("bike-bundle-container--hidden")) {
        var itemsToAdd = Array.from(document.querySelectorAll(".bike-bundle-item[data-variant-id]")).map(function(each) {
            return {id: each.dataset.variantId, quantity: 1}
        })
        bundleItemsToAdd.push(...itemsToAdd)
        // guardianAPI.addMultipleItemsToCart(itemsToAdd)
      }

      // guardianAPI.getLockAndPumpsToAdd(accessoryOfferAdded)
      guardianAPI.getLockAndPumpsToAdd()
      .then(lockAndPumpsToAdd => {
        console.log("optionalAddonItems", optionalAddonItems)
        console.log("optionalBundles", optionalBundles)
        console.log("bundleItemsToAdd", bundleItemsToAdd)
        console.log("lockAndPumpsToAdd", lockAndPumpsToAdd)
        let allAddons = [...optionalAddonItems, ...optionalBundles, ...bundleItemsToAdd, ...lockAndPumpsToAdd]
        if (allAddons.length) {
          guardianAPI.addMultipleItemsToCart(allAddons)
        }
        if (lockAndPumpsToAdd.length) {
          guardianAPI.setCookie('lock_and_pump', true)
        }
      })


//       guardianAPI.handleWildFree();
    },
    error: function(XMLHttpRequest, textStatus) {
      if ((typeof errorCallback) === 'function') {
        errorCallback(XMLHttpRequest, textStatus);
      }
      else {
        ShopifyAPI.onError(XMLHttpRequest, textStatus);
      }
      $body.trigger('errorAddItem.ajaxCart', [XMLHttpRequest, textStatus]);
    },
    complete: function(jqxhr, text) {
      $body.trigger('completeAddItem.ajaxCart', [this, jqxhr, text]);
      albar.RightDrawer.open();
    }
  };
  jQuery.ajax(params);

  
};

// Get from cart.js returns the cart in JSON
ShopifyAPI.getCart = function(callback, openCart) {
  $(document.body).trigger('beforeGetCart.ajaxCart');
  
      $.ajax({
//         url : '/cart.js',
//         dataType: 'json',
        url : '/cart?view=alternate.json',
        type : 'GET',
        success : function(data) {
//           var cart = data;
          var cart = JSON.parse(data)
          if (data.error === true ) {
              console.log("error", data.error)
          } else {
            if ((typeof callback) === 'function') {
              callback(cart, openCart);
            } else {
              ShopifyAPI.onCartUpdate(cart);
            }
            $(document.body).trigger('afterGetCart.ajaxCart', cart);
          }
        },
        error : function(request,error) {
          console.log(error);
        }
      });
  
//   jQuery.getJSON('/cart.js', function (cart, textStatus) {
//     if ((typeof callback) === 'function') {
//       callback(cart);
//     }
//     else {
//       ShopifyAPI.onCartUpdate(cart);
//     }
//     $(document.body).trigger('afterGetCart.ajaxCart', cart);
//   });
};

// POST to cart/change.js returns the cart in JSON
ShopifyAPI.changeItem = function(line, quantity, callback) {
  var $body = $(document.body),
  params = {
    type: 'POST',
    url: '/cart/change.js',
    data: 'quantity=' + quantity + '&line=' + line,
    dataType: 'json',
    beforeSend: function() {
      $body.trigger('beforeChangeItem.ajaxCart', [line, quantity]);
    },
    success: function(cart) {
      if ((typeof callback) === 'function') {
        callback(cart);
      }
      else {
        ShopifyAPI.onCartUpdate(cart);
      }
      $body.trigger('afterChangeItem.ajaxCart', [line, quantity, cart]);
    },
    error: function(XMLHttpRequest, textStatus) {
      $body.trigger('errorChangeItem.ajaxCart', [XMLHttpRequest, textStatus]);
      ShopifyAPI.onError(XMLHttpRequest, textStatus);
    },
    complete: function(jqxhr, text) {
      $body.trigger('completeChangeItem.ajaxCart', [this, jqxhr, text]);
    }
  };
  jQuery.ajax(params);
};

/*============================================================================
  Ajax Shopify Add To Cart
==============================================================================*/
var ajaxCart = (function(module, $) {

  'use strict';

  // Public functions
  var init, loadCart;

  // Private general variables
  var settings, isUpdating, $body;

  // Private plugin variables
  var $formContainer, $addToCart, $cartCountSelector, $cartCostSelector, $cartContainer, $drawerContainer;

  // Private functions
  var updateCountPrice, formOverride, itemAddedCallback, itemErrorCallback, cartUpdateCallback, buildCart, cartCallback, adjustCart, adjustCartCallback, createQtySelectors, qtySelectors, validateQty;

  /*============================================================================
    Initialise the plugin and define global options
  ==============================================================================*/
  init = function (options) {

    // Default settings
    settings = {
      formSelector       : 'form[action^="/cart/add"]',
      cartContainer      : '#AlbarCartContainer',
      addToCartSelector  : 'input[type="submit"]',
      cartCountSelector  : null,
      cartCostSelector   : null,
      moneyFormat        : '$',
      disableAjaxCart    : false,
      enableQtySelectors : true
    };

    // Override defaults with arguments
    $.extend(settings, options);

    // Select DOM elements
    $formContainer     = $(settings.formSelector);
    $cartContainer     = $(settings.cartContainer);
    $addToCart         = $formContainer.find(settings.addToCartSelector);
    $cartCountSelector = $(settings.cartCountSelector);
    $cartCostSelector  = $(settings.cartCostSelector);

    // General Selectors
    $body = $(document.body);

    // Track cart activity status
    isUpdating = false;

    // Setup ajax quantity selectors on the any template if enableQtySelectors is true
    if (settings.enableQtySelectors) {
      qtySelectors();
    }

    // Take over the add to cart form submit action if ajax enabled
    if (!settings.disableAjaxCart && $addToCart.length) {
      formOverride();
    }

    // Run this function in case we're using the quantity selector outside of the cart
    adjustCart();
  };

  loadCart = function (openCart = true) {
    if (openCart) {
      $body.addClass('drawer--is-loading');
      $('#mini-cart-overlay').addClass("show-overlay_al32");
      albar.RightDrawer.open();
    }
    ShopifyAPI.getCart(cartUpdateCallback);
  };

  updateCountPrice = function (cart) {
    if ($cartCountSelector) {
      $cartCountSelector.html(cart.item_count).removeClass('hidden-count');

      if (cart.item_count === 0) {
        $cartCountSelector.addClass('hidden-count');
        $(".site-header__cart").addClass("cart_header_empty");
      }else{
		$(".site-header__cart").removeClass("cart_header_empty");        
      }
    }
    if ($cartCostSelector) {
      $cartCostSelector.html(Shopify.formatMoney(cart.total_price, settings.moneyFormat));
    }
  };

  formOverride = function () {
    $formContainer.on('submit', function(evt) {
      evt.preventDefault();

      // Add class to be styled if desired
      $addToCart.removeClass('is-added').addClass('is-adding');

      // Remove any previous quantity errors
      $('.qty-error').remove();

      ShopifyAPI.addItemFromForm(evt.target, itemAddedCallback, itemErrorCallback);
    });
  };

  itemAddedCallback = function (product) {
    $addToCart.removeClass('is-adding').addClass('is-added');

    ShopifyAPI.getCart(cartUpdateCallback);
  };

  itemErrorCallback = function (XMLHttpRequest, textStatus) {
    var data = eval('(' + XMLHttpRequest.responseText + ')');
    $addToCart.removeClass('is-adding is-added');

    if (!!data.message) {
      if (data.status == 422) {
        $formContainer.after('<div class="errors qty-error">'+ data.description +'</div>')
      }
    }
  };

  cartUpdateCallback = function (cart, cartOpen = true) {
    // Update quantity and price
    updateCountPrice(cart);
    buildCart(cart, cartOpen);
    document.dispatchEvent(new CustomEvent("cartUpdate", {detail: cart}))
  };


  Handlebars.registerHelper('eq', function(a, b) {
      return a === b;
  });

  buildCart = function (cart, cartOpen=true) {
    // Start with a fresh cart div
    $cartContainer.empty();

    var cust_status = $(".customer_status a").attr("class");
    //alert("Customer Status"+cust_status);
     
    // Show empty cart
    if (cart.item_count === 0 || cust_status == "Login") {
      $('.albar_ajaxcart__header').hide()
      $("#CartCount").text("0");
      $cartContainer
      	//.append('<div class="cart-icon-row"><i aria-hidden="true" class="fa fa-shopping-cart"></i></div>');
        .append('<div class="cart-icon-row"><i aria-hidden="true" class="fa fa-shopping-cart"></i></div><p class="cart_empty_msg">' + "Your shopping cart is currently empty!" + '</p>');
      $cartContainer
        .append('<div class="ajaxcart__footer empty_cart_msg_shop"><p class="button keep-shopping-btn"> <a class="" href="/" title="Keep Shopping" style="text-transform: uppercase;">Keep Shopping</a></p> </div>');   
	   $("#CartDrawer").css("height", "auto");
      cartCallback(cart, cartOpen);
      //$(".empty_cart_msg_shop").show();
      return;
    } else {
      $('.albar_ajaxcart__header').show()
    }
    /*else{
      $("#CartDrawer").css("height", "375px");      
    }*/

    // Handlebars.js cart layout
    var items = [],
        item = {},
        data = {},
        source = $("#CartTemplate").html(),
        template = Handlebars.compile(source);
    
    var totalDiscounts = 0;

    var hasBike = cart.items.some(function(item) {return item.product_type == 'Kids Bikes'})
    var onlyGiftCard = cart.items.every(function(item) {return item.product_type == 'Gift Card'})
    var shippingCost = onlyGiftCard ? 0 : hasBike ? 2900 : 499;

    // Add each item to our handlebars.js data
    $.each(cart.items, function(index, cartItem) {
      var isBike = cartItem.product_type == 'Kids Bikes'

      /* Hack to get product image thumbnail
       *   - If image is not null
       *     - Remove file extension, add _small, and re-add extension
       *     - Create server relative link
       *   - A hard-coded url of no-image
      */
      if (cartItem.image != null){
        var prodImg = cartItem.image.replace(/(\.[^.]*)$/, "_small$1").replace('http:', '');
      } else {
        var prodImg = "//cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif";
      }
      var currentDiscount = 0;
      // if (cartItem.properties && cartItem.properties['Free']) {
      //   var totalDiscount = 2000 * cartItem.quantity
      //   totalDiscounts += totalDiscount
      // }
    
      var originalLinePrice = cartItem.original_line_price
      var allowedGbabValues = []
      console.log("cartItem.properties", cartItem.properties)
      for (var cartItemProperty in cartItem.properties) {
        if (cartItemProperty == "_discount" && hasBike) {
          currentDiscount = cartItem.properties["_discount"]*100
          originalLinePrice = originalLinePrice-(currentDiscount)
          totalDiscounts += cartItem.properties["_discount"]*100
        } else if (allowedGbabValues.includes(cartItem.properties[cartItemProperty]) && isBike) {
          currentDiscount = 1000*cartItem.quantity
          originalLinePrice = originalLinePrice-(currentDiscount)
          totalDiscounts += 1000*cartItem.quantity
        }
        if (cartItemProperty[0] == "_") {
          delete cartItem.properties[cartItemProperty]
        }
      }
      // Create item's data object and add to 'items' array


      item = {
        key: cartItem.key,
        line: index + 1, // Shopify uses a 1+ index in the API
        url: cartItem.url,
        img: prodImg,
        name: cartItem.product_title,
        variation: cartItem.variant_title,
        showVariation: !cartItem.product_tags.includes('hide_options'),
        properties: cartItem.properties,
        itemAdd: cartItem.quantity + 1,
        itemMinus: cartItem.quantity - 1,
        itemQty: cartItem.quantity,
        price: Shopify.formatMoney(cartItem.price, settings.moneyFormat),
        compareAtPrice: cartItem.product_title != 'Adult Bike' && cartItem.compare_at_price && Shopify.formatMoney(cartItem.compare_at_price, settings.moneyFormat),
        compareAtLinePrice: cartItem.product_title != 'Adult Bike' && cartItem.compare_at_price && Shopify.formatMoney(cartItem.compare_at_price*cartItem.quantity, settings.moneyFormat),
        vendor: cartItem.vendor,
        linePrice: cartItem.line_price == 0 ? "FREE" : Shopify.formatMoney(cartItem.line_price, settings.moneyFormat),
        originalLinePrice: originalLinePrice == 0 ? "FREE" : Shopify.formatMoney(originalLinePrice, settings.moneyFormat),
        // originalLinePrice: originalLinePrice == 0 ? "FREE" : Shopify.formatMoney(cartItem.line_price, settings.moneyFormat),
        // originalLinePrice: Shopify.formatMoney(cartItem.line_price, settings.moneyFormat),
        // originalLinePriceWithoutDiscount: (totalDiscounts > 0) || (cartItem.line_price != cartItem.original_line_price) ? cartItem.compare_at_price > cartItem.original_line_price ? Shopify.formatMoney(cartItem.compare_at_price, settings.moneyFormat) : Shopify.formatMoney(cartItem.original_line_price, settings.moneyFormat) : null,
        originalLinePriceWithoutDiscount: (totalDiscounts > 0) || (cartItem.line_price != cartItem.original_line_price) ? Shopify.formatMoney(cartItem.original_line_price, settings.moneyFormat) : null,
        finalLinePrice: cartItem.final_line_price-currentDiscount == 0 ? "FREE" : Shopify.formatMoney(cartItem.final_line_price-currentDiscount, settings.moneyFormat),
        finalLinePriceWithoutDiscount: currentDiscount > 0 ? Shopify.formatMoney(cartItem.final_line_price, settings.moneyFormat) : null,
        discounts: cartItem.discounts,
        discountsApplied: cartItem.line_price === cartItem.original_line_price ? false : true,
        showFreeSeat: cartItem.handle === '14-inch-bike' || cartItem.handle === '16-inch-bike'
      };
      console.log("item", item)

      items.push(item);
    });

    // Gather all cart data and add to DOM
    data = {
      items: items,
      note: cart.note,
      totalDiscounts: Shopify.formatMoney(totalDiscounts, settings.moneyFormat),
      totalPrice: Shopify.formatMoney(cart.total_price, settings.moneyFormat),
      totalCartDiscount: cart.total_discount === 0 ? 0 : "Translation missing: en.cart.general.savings_html".replace('[savings]', Shopify.formatMoney(cart.total_discount, settings.moneyFormat)),
      totalCartDiscountApplied: cart.total_discount === 0 ? false : true,
      originalTotalPrice: Shopify.formatMoney(cart.original_total_price, settings.moneyFormat),
      itemsSubtotalPrice: Shopify.formatMoney(cart.items_subtotal_price-totalDiscounts, settings.moneyFormat),
      itemsSubtotalPriceWithShipping: Shopify.formatMoney(cart.items_subtotal_price+shippingCost, settings.moneyFormat),
      shippingCost: Shopify.formatMoney(shippingCost, settings.moneyFormat)
    }
    $cartContainer.append(template(data));
    $('.albar_ajaxcart__footer .affirm-as-low-as').attr('data-amount',cart.total_price);
    // $('#top-cart-price').text(Shopify.formatMoney(cart.total_price, settings.moneyFormat))
    $('#top-cart-price').text(data.itemsSubtotalPrice)
    //affirm.ui.refresh();     
    
    cartCallback(cart, cartOpen);
  };

  cartCallback = function(cart, cartOpen = true) {
    $body.removeClass('drawer--is-loading');
    if (cartOpen) {
      $body.trigger('afterCartLoad.ajaxCart', cart);
    }

   if (window.BOLD && BOLD.common && BOLD.common.eventEmitter &&
          typeof BOLD.common.eventEmitter.emit === 'function'){
        BOLD.common.eventEmitter.emit('BOLD_COMMON_cart_loaded');
      }

    if (window.Shopify && Shopify.StorefrontExpressButtons) {
      Shopify.StorefrontExpressButtons.initialize();
    }
    guardianAPI.afterCartCallback(cart);
    guardianAPI.gorgiasCaptureCart();


    // var hasLayawayBike = cart.items.some(function(each) {
    //   return ["balance-bike", "14-inch-bike", "16-inch-bike", "20-inch-small-bike", "20-inch-large-bike", "24-inch-bike"].indexOf(each.handle) > -1
    // })
    // if (hasLayawayBike) {
    //   document.querySelector('#holiday-delivery-container').style.display = 'block';
    //   var checkoutInputLayaway = document.querySelector("#checkout_attributes_holiday_delivery")
    //   var layawayInputs = document.querySelectorAll('.holiday-delivery-option-input')
    //   layawayInputs.forEach(function(layawayInput) {
    //     layawayInput.addEventListener('change', function(event) {
    //       if (event.target.dataset.value == 'null') {
    //         checkoutInputLayaway.removeAttribute('value')
    //         guardianAPI.eraseCookie('layaway')
    //       } else {
    //         checkoutInputLayaway.value = event.target.dataset.value
    //         guardianAPI.setCookie('layaway', event.target.dataset.value)
    //       }
    //     })
    //   })
    //   var layawayCookie = guardianAPI.getCookie('layaway')
    //   if (layawayCookie) {
    //     checkoutInputLayaway.value = layawayCookie
    //     document.querySelector('.holiday-delivery-option-input[data-value="'+layawayCookie+'"]').checked = true;
    //   }
    // } else {
    //   document.querySelector('#holiday-delivery-container').remove()
    // }
    

    
    if (affirm && affirm.ui && affirm.ui.refresh) {
      affirm.ui.refresh();
    }
  };

  adjustCart = function () {
    // Delegate all events because elements reload with the cart

    // Add or remove from the quantity
    $body.on('click', '.ajaxcart__qty-adjust', function() {
      //affirm.ui.refresh();
      
      if (isUpdating) {
        return;
      }

      var $el = $(this),
          line = $el.data('line'),
          $qtySelector = $el.siblings('.ajaxcart__qty-num'),
          qty = parseInt($qtySelector.val().replace(/\D/g, ''));

      var qty = validateQty(qty);

      // Add or subtract from the current quantity
      if ($el.hasClass('ajaxcart__qty--plus')) {
        qty += 1;
      } else {
        qty -= 1;
        if (qty <= 0) qty = 0;
      }

      // If it has a data-line, update the cart.
      // Otherwise, just update the input's number
      if (line) {
        updateQuantity(line, qty);
      } else {
        $qtySelector.val(qty);
      }
    });

    // Update quantity based on input on change
    $body.on('change', '.ajaxcart__qty-num', function() {
      if (isUpdating) {
        return;
      }

      var $el = $(this),
          line = $el.data('line'),
          qty = parseInt($el.val().replace(/\D/g, ''));

      var qty = validateQty(qty);

      // If it has a data-line, update the cart
      if (line) {
        updateQuantity(line, qty);
      }
    });

    // Prevent cart from being submitted while quantities are changing
    $body.on('submit', 'form.ajaxcart', function(evt) {
      if (isUpdating) {
        evt.preventDefault();
      }
    });

    // Highlight the text when focused
    $body.on('focus', '.ajaxcart__qty-adjust', function() {
      var $el = $(this);
      setTimeout(function() {
        $el.select();
      }, 50);
    });

    function updateQuantity(line, qty) {
      isUpdating = true;

      // Add activity classes when changing cart quantities
      var $row = $('.ajaxcart__row[data-line="' + line + '"]').addClass('is-loading');

      if (qty === 0) {
        $row.parent().addClass('is-removed');
      }

      // Slight delay to make sure removed animation is done
      setTimeout(function() {
        ShopifyAPI.changeItem(line, qty, adjustCartCallback);
      }, 250);
    }

    // Save note anytime it's changed
    $body.on('change', 'textarea[name="note"]', function() {
      var newNote = $(this).val();

      // Update the cart note in case they don't click update/checkout
      ShopifyAPI.updateCartNote(newNote, function(cart) {});
    });
  };

  adjustCartCallback = function (cart) {
    // Update quantity and price
    updateCountPrice(cart);

    // Reprint cart on short timeout so you don't see the content being removed
    setTimeout(function() {
      isUpdating = false;
      ShopifyAPI.getCart(buildCart);
    }, 150)

    document.dispatchEvent(new CustomEvent("cartUpdate", {detail: cart}))
  };

  createQtySelectors = function() {
    // If there is a normal quantity number field in the ajax cart, replace it with our version
    if ($('input[type="number"]', $cartContainer).length) {
      $('input[type="number"]', $cartContainer).each(function() {
        var $el = $(this),
            currentQty = $el.val();

        var itemAdd = currentQty + 1,
            itemMinus = currentQty - 1,
            itemQty = currentQty;

        var source   = $("#AjaxQty").html(),
            template = Handlebars.compile(source),
            data = {
              key: $el.data('id'),
              itemQty: itemQty,
              itemAdd: itemAdd,
              itemMinus: itemMinus
            };

        // Append new quantity selector then remove original
        $el.after(template(data)).remove();
      });
    }
  };

  qtySelectors = function() {
    // Change number inputs to JS ones, similar to ajax cart but without API integration.
    // Make sure to add the existing name and id to the new input element
    var numInputs = $('input[type="number"]');

    if (numInputs.length) {
      numInputs.each(function() {
        var $el = $(this),
            currentQty = $el.val(),
            inputName = $el.attr('name'),
            inputId = $el.attr('id');

        var itemAdd = currentQty + 1,
            itemMinus = currentQty - 1,
            itemQty = currentQty;

        var source   = $("#JsQty").html(),
            template = Handlebars.compile(source),
            data = {
              key: $el.data('id'),
              itemQty: itemQty,
              itemAdd: itemAdd,
              itemMinus: itemMinus,
              inputName: inputName,
              inputId: inputId
            };

        // Append new quantity selector then remove original
        $el.after(template(data)).remove();
      });

      // Setup listeners to add/subtract from the input
      $('.js-qty__adjust').on('click', function() {
        var $el = $(this),
            id = $el.data('id'),
            $qtySelector = $el.siblings('.js-qty__num'),
            qty = parseInt($qtySelector.val().replace(/\D/g, ''));

        var qty = validateQty(qty);

        // Add or subtract from the current quantity
        if ($el.hasClass('js-qty__adjust--plus')) {
          qty += 1;
        } else {
          qty -= 1;
          if (qty <= 1) qty = 1;
        }

        // Update the input's number
        $qtySelector.val(qty);
      });
    }
  };

  validateQty = function (qty) {
    if((parseFloat(qty) == parseInt(qty)) && !isNaN(qty)) {
      // We have a valid number!
    } else {
      // Not a number. Default to 1.
      qty = 1;
    }
    return qty;
  };

  module = {
    init: init,
    load: loadCart
  };

  return module;

}(ajaxCart || {}, jQuery));
